/**
 * Vibeship DevTools Type Definitions
 * 
 * @module @vibeship/devtools
 */

// Re-export all types from sub-modules
export * from './tasks';
export * from './config';
export * from './server';
export * from './cli';
export * from './providers';
export * from './ui';
export * from './ai-settings';

/**
 * Version of the Vibeship DevTools package
 */
export declare const VERSION: string;

/**
 * Common error class for Vibeship DevTools
 */
export class VibeshipError extends Error {
  code?: string;
  details?: Record<string, any>;
  
  constructor(message: string, code?: string, details?: Record<string, any>) {
    super(message);
    this.name = 'VibeshipError';
    this.code = code;
    this.details = details;
  }
}

// Backwards compatibility
export class VibecodeError extends VibeshipError {}

/**
 * Result type for async operations
 */
export type AsyncResult<T, E = Error> = 
  | { success: true; data: T }
  | { success: false; error: E };

/**
 * Pagination options
 */
export interface PaginationOptions {
  /** Page number (1-based) */
  page?: number;
  /** Items per page */
  limit?: number;
  /** Sort field */
  sortBy?: string;
  /** Sort order */
  sortOrder?: 'asc' | 'desc';
}

/**
 * Paginated response
 */
export interface PaginatedResponse<T> {
  /** Data items */
  data: T[];
  /** Total number of items */
  total: number;
  /** Current page */
  page: number;
  /** Items per page */
  limit: number;
  /** Total pages */
  totalPages: number;
  /** Has next page */
  hasNext: boolean;
  /** Has previous page */
  hasPrev: boolean;
}